
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3183_3816)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.0334 0.421875C10.4279 0.421875 10.7477 0.753515 10.7477 1.16262V12.523L14.9693 8.14503C15.2482 7.8557 15.7005 7.8557 15.9794 8.14503C16.2584 8.43429 16.2584 8.90333 15.9794 9.19259L10.5385 14.835C10.2596 15.1243 9.80727 15.1243 9.52834 14.835L4.08738 9.19259C3.80843 8.90333 3.80843 8.43429 4.08738 8.14503C4.36632 7.8557 4.81859 7.8557 5.09753 8.14503L9.31912 12.523V1.16262C9.31912 0.753515 9.63891 0.421875 10.0334 0.421875ZM1.1115 12.2638C1.50599 12.2638 1.82579 12.5955 1.82579 13.0046V16.014C1.82579 17.2414 2.78504 18.2362 3.96865 18.2362H16.0315C17.2151 18.2362 18.1743 17.2414 18.1743 16.014V13.0046C18.1743 12.5955 18.4941 12.2638 18.8886 12.2638C19.2831 12.2638 19.6029 12.5955 19.6029 13.0046V16.014C19.6029 18.0596 18.0041 19.7177 16.0315 19.7177H3.96865C1.99606 19.7177 0.397217 18.0596 0.397217 16.014V13.0046C0.397217 12.5955 0.717017 12.2638 1.1115 12.2638Z","fill":"#8338EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3183_3816"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"white"}})])])])
          )
        }
      }
    